import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import React from 'react'
import { ShareIcon, TryOnIcon, VariantsIcon, VariantsIconFilled } from '../../assets/icons/icons'
import { logoURL } from '../../shared/constants'
import DownloadAppButton from '../DownloadAppButton/DownloadAppButton'
import IconWrapper from '../IconWrapper/IconWrapper'
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const DownloadAppView = () => {

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Grid container direction={"column"} justifyContent={"center"}>
        <Grid item container justifyContent={"center"}>
            {matches ? <img width={"346px"} height={"auto"} src={logoURL} alt="TRYO"/> : <img width={"221px"} height={"auto"} src={logoURL} alt="TRYO"/>}
        </Grid>
        <Grid item pt={3} px={1}>
            <Typography align='center' variant='customBody'>You’ve seen our life-like models. Now download the app for an even cooler experience in AR.</Typography>
        </Grid>
        {matches ? 
        <Grid item container justifyContent={{md:"space-between", xs:"space-evenly"}} pt={3}>
            <Grid item container width={"195px"} height={"46px"} alignItems={"center"} my={2}>
                <Grid item>
                <IconWrapper icon={<TryOnIcon/>}/>
                </Grid>
                <Grid item width={"133px"} height={"36px"} marginLeft={2}>
                    <Typography align={"left"} variant='customBodyXsCondensed'>Try-on hundreds of items in Augmented Reality</Typography>
                </Grid>
            </Grid>
            <Grid item container width={"152px"} height={"46px"} alignItems={"center"} my={2}>
                <Grid item>
                <IconWrapper icon={<VariantsIconFilled sx={{marginLeft:0.6}}/>}/>
                </Grid>
                <Grid item width={"90px"} height={"36px"} marginLeft={2}>
                    <Typography align='left' variant='customBodyXsCondensed'>Cycle through variants and colorways</Typography>
                </Grid>
            </Grid>
            <Grid item container width={"204px"} height={"46px"} alignItems={"center"} my={2}>
                <Grid item>
                <IconWrapper icon={<ShareIcon/>}/>
                </Grid>
                <Grid item width={"142px"} height={"36px"} marginLeft={2}>
                    <Typography align='left' variant='customBodyXsCondensed'>Share photos of yourself trying out the collection</Typography>
                </Grid>
            </Grid>
        </Grid> : 
        <Grid item container direction={"column"} alignItems={"center"} pt={3}>
            <Grid item container width={"204px"} height={"46px"} alignItems={"center"} my={1.5}>
                <Grid item>
                <IconWrapper icon={<TryOnIcon/>}/>
                </Grid>
                <Grid item width={"133px"} height={"36px"} marginLeft={2}>
                    <Typography align={"left"} variant='customBodyXsCondensed'>Try-on hundreds of items in Augmented Reality</Typography>
                </Grid>
            </Grid>
            <Grid item container width={"204px"} height={"46px"} alignItems={"center"} my={1.5}>
                <Grid item>
                <IconWrapper icon={<VariantsIconFilled sx={{marginLeft:0.6}}/>}/>
                </Grid>
                <Grid item width={"90px"} height={"36px"} marginLeft={2}>
                    <Typography align='left' variant='customBodyXsCondensed'>Cycle through variants and colorways</Typography>
                </Grid>
            </Grid>
            <Grid item container width={"204px"} height={"46px"} alignItems={"center"} mt={1.5}>
                <Grid item>
                <IconWrapper icon={<ShareIcon/>}/>
                </Grid>
                <Grid item width={"142px"} height={"36px"} marginLeft={2}>
                    <Typography align='left' variant='customBodyXsCondensed'>Share photos of yourself trying out the collection</Typography>
                </Grid>
            </Grid>
        </Grid>}
        <Grid item container pt={4} justifyContent={"center"}>
            <DownloadAppButton/>
        </Grid>
    </Grid>
  )
}

export default DownloadAppView